// import React, { useState } from 'react';
// import { MessageCircle, X, Send, Bot } from 'lucide-react';

// const ChatHeader = ({ onClose }) => (
//   <div style={{
//     padding: '16px',
//     background: 'linear-gradient(to right, #024A59, #0A6B7D)',
//     color: 'white',
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     borderTopLeftRadius: '16px',
//     borderTopRightRadius: '16px'
//   }}>
//     <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
//       <Bot style={{ height: '24px', width: '24px', color: '#FFA916' }} />
//       <h3 style={{ fontWeight: 600, fontSize: '18px' }}>Statify Support</h3>
//     </div>
//     <button
//       onClick={onClose}
//       style={{
//         background: 'transparent',
//         border: 'none',
//         cursor: 'pointer',
//         padding: '4px',
//         borderRadius: '50%',
//         transition: 'all 0.2s',
//         color: 'white',
//         ':hover': { color: '#FFA916' }
//       }}
//     >
//       <X style={{ height: '20px', width: '20px' }} />
//     </button>
//   </div>
// );

// const ChatMessages = ({ messages, isTyping }) => (
//   <div style={{
//     height: '384px',
//     padding: '16px',
//     background: 'linear-gradient(to bottom, #F5F5F5 0%, #EAEAEA 100%)',
//     overflowY: 'auto'
//   }}>
//     <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
//       {messages.map((message, index) => (
//         <div
//           key={index}
//           style={{
//             display: 'flex',
//             justifyContent: message.isUser ? 'flex-end' : 'flex-start',
//             animation: 'messageEnter 0.3s ease-out'
//           }}
//         >
//           <div style={{
//             maxWidth: '85%',
//             padding: '12px',
//             borderRadius: '16px',
//             fontSize: '14px',
//             lineHeight: '1.4',
//             ...(message.isUser ? {
//               background: '#FFA916',
//               color: '#024A59',
//               borderBottomRightRadius: '4px'
//             } : {
//               background: 'white',
//               color: '#374151',
//               borderBottomLeftRadius: '4px',
//               boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//               border: '1px solid rgba(255,169,22,0.1)'
//             })
//           }}>
//             {message.content}
//           </div>
//         </div>
//       ))}
//       {isTyping && (
//         <div style={{
//           display: 'flex',
//           alignItems: 'center',
//           gap: '8px',
//           color: '#024A59',
//           animation: 'typingIndicatorEnter 0.2s ease-out'
//         }}>
//           <div style={{ display: 'flex', gap: '6px' }}>
//             {[0, 0.2, 0.4].map((delay, i) => (
//               <div
//                 key={i}
//                 style={{
//                   width: '10px',
//                   height: '10px',
//                   background: '#FFA916',
//                   borderRadius: '50%',
//                   animation: `bounce 1s infinite ${delay}s`
//                 }}
//               />
//             ))}
//           </div>
//           <span style={{ fontSize: '14px', fontWeight: 500 }}>Typing...</span>
//         </div>
//       )}
//     </div>
//   </div>
// );

// const ChatInput = ({ input, onChange, onSend }) => (
//   <form
//     onSubmit={onSend}
//     style={{
//       padding: '16px',
//       background: 'white',
//       borderTop: '1px solid rgba(0,0,0,0.1)',
//       borderBottomLeftRadius: '16px',
//       borderBottomRightRadius: '16px'
//     }}
//   >
//     <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
//       <input
//         type="text"
//         value={input}
//         onChange={(e) => onChange(e.target.value)}
//         placeholder="Type your message..."
//         style={{
//           flex: 1,
//           borderRadius: '12px',
//           border: '1px solid rgba(0,0,0,0.1)',
//           padding: '10px 16px',
//           fontSize: '14px',
//           color: '#374151',
//           outline: 'none',
//           transition: 'all 0.2s',
//           ':focus': {
//             borderColor: '#FFA916',
//             boxShadow: '0 0 0 2px rgba(255,169,22,0.2)'
//           }
//         }}
//       />
//       <button
//         type="submit"
//         style={{
//           padding: '10px',
//           borderRadius: '12px',
//           background: input.trim() ? '#FFA916' : 'rgba(0,0,0,0.1)',
//           border: 'none',
//           cursor: input.trim() ? 'pointer' : 'not-allowed',
//           transition: 'all 0.2s',
//           ':hover': input.trim() ? { background: '#E69500' } : {},
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center'
//         }}
//         disabled={!input.trim()}
//       >
//         <Send style={{ height: '20px', width: '20px', color: 'white' }} />
//       </button>
//     </div>
//   </form>
// );

// const generateBotResponse = (input) => {
//   const lowerInput = input.toLowerCase();
//   if (lowerInput.includes('erp')) {
//     return 'Our ERP solutions are tailored to your business needs. Which industry are you in?';
//   } else if (lowerInput.includes('pricing')) {
//     return 'We offer flexible pricing models based on your requirements. Would you like a customized quote?';
//   } else if (lowerInput.includes('support')) {
//     return 'Our team provides 24/7 support. Please describe your issue and we\'ll connect you with an expert.';
//   } else {
//     const whatsappNumber = '254728813009';
//     const encodedMessage = encodeURIComponent(input);
//     const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
//     return (
//       <span>
//         For detailed assistance, continue on{' '}
//         <a
//           href={whatsappUrl}
//           target="_blank"
//           rel="noopener noreferrer"
//           style={{
//             color: '#FFA916',
//             fontWeight: 500,
//             textDecoration: 'none',
//             ':hover': { textDecoration: 'underline' }
//           }}
//         >
//           WhatsApp
//         </a>
//       </span>
//     );
//   }
// };

// export function ChatWidget() {
//   const [isOpen, setIsOpen] = useState(false);
//   const [messages, setMessages] = useState([]);
//   const [input, setInput] = useState('');
//   const [isTyping, setIsTyping] = useState(false);

//   const handleSendMessage = (e) => {
//     e.preventDefault();
//     if (!input.trim()) return;

//     const userMessage = { content: input, isUser: true };
//     setMessages((prev) => [...prev, userMessage]);

//     setIsTyping(true);
//     setTimeout(() => {
//       const botReply = generateBotResponse(input);
//       const botMessage = { content: botReply, isUser: false };
//       setMessages((prev) => [...prev, botMessage]);
//       setIsTyping(false);
//     }, 1500);

//     setInput('');
//   };

//   return (
//     <div style={{ position: 'fixed', bottom: '24px', right: '24px', zIndex: 50 }}>
//       <style>
//         {`
//           @keyframes messageEnter {
//             from { opacity: 0; transform: translateY(10px); }
//             to { opacity: 1; transform: translateY(0); }
//           }
//           @keyframes typingIndicatorEnter {
//             from { opacity: 0; transform: translateX(-10px); }
//             to { opacity: 1; transform: translateX(0); }
//           }
//           @keyframes bounce {
//             0%, 100% { transform: translateY(0); }
//             50% { transform: translateY(-5px); }
//           }
//           .chat-scrollbar::-webkit-scrollbar {
//             width: 6px;
//           }
//           .chat-scrollbar::-webkit-scrollbar-track {
//             background: rgba(2,74,89,0.05);
//           }
//           .chat-scrollbar::-webkit-scrollbar-thumb {
//             background: rgba(2,74,89,0.2);
//             border-radius: 3px;
//           }
//         `}
//       </style>
      
//       {!isOpen ? (
//         <button
//           onClick={() => setIsOpen(true)}
//           style={{
//             background: '#FFA916',
//             color: '#024A59',
//             borderRadius: '50%',
//             padding: '16px',
//             boxShadow: '0 4px 20px rgba(2,74,89,0.2)',
//             border: 'none',
//             cursor: 'pointer',
//             transition: 'all 0.3s',
//             animation: 'widgetEntrance 0.3s ease-out',
//             ':hover': { transform: 'scale(1.05)', background: '#E69500' }
//           }}
//         >
//           <MessageCircle style={{ height: '28px', width: '28px' }} />
//         </button>
//       ) : (
//         <div style={{
//           background: 'white',
//           borderRadius: '16px',
//           boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
//           width: '384px',
//           overflow: 'hidden',
//           animation: 'windowOpen 0.3s ease-out'
//         }}>
//           <ChatHeader onClose={() => setIsOpen(false)} />
//           <ChatMessages messages={messages} isTyping={isTyping} />
//           <ChatInput input={input} onChange={setInput} onSend={handleSendMessage} />
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useState, useEffect } from 'react';
import { MessageCircle, X, Send, Bot, MessageCircleDashed, } from 'lucide-react';
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';

emailjs.init('D8lmS3WG4QkNAxEg9');

const ChatHeader = ({ onClose }) => (
  <div className="chat-header">
    <div className="header-content">
      <Bot className="bot-icon" />
      <h3>Send Message</h3>
    </div>
    <button onClick={onClose} className="close-button">
      <X />
    </button>
  </div>
);

const ChatMessages = ({ messages, isTyping }) => (
  <div className="chat-messages">
    <div className="messages-container">
      {messages.map((message, index) => (
        <div key={index} className={`message ${message.isUser ? 'user' : 'bot'}`}>
          <div className="message-content">{message.content}</div>
        </div>
      ))}
      {isTyping && (
        <div className="typing-indicator">
          <div className="dots">
            {[0, 0.2, 0.4].map((delay, i) => (
              <div key={i} className="dot" style={{ animationDelay: `${delay}s` }} />
            ))}
          </div>
          <span>Typing...</span>
        </div>
      )}
    </div>
  </div>
);

const ChatInput = ({ formData, onChange, onSend, isSending }) => (
  <form onSubmit={onSend} className="chat-input">
    <div className="input-fields">
      <input
        type="text"
        name="from_name"
        value={formData.from_name}
        onChange={(e) => onChange('from_name', e.target.value)}
        placeholder="Enter Your Name"
        required
      />
      <input
        type="email"
        name="from_email"
        value={formData.from_email}
        onChange={(e) => onChange('from_email', e.target.value)}
        placeholder="Enter Your Email"
        required
        pattern="[^\s@]+@[^\s@]+\.[^\s@]+"
        title="Please enter a valid email address (e.g., user@example.com)"
      />
      <input
        type="text"
        name="from_phone"
        value={formData.from_phone}
        onChange={(e) => onChange('from_phone', e.target.value)}
        placeholder="Enter Your Phone Number"
        pattern="^\d{10}$"
        title="Mobile number must be 10 digits"
        required

      />
      <input
        type="text"
        name="from_subject"
        value={formData.from_subject}
        onChange={(e) => onChange('from_subject', e.target.value)}
        placeholder="Subject"
        required
      />
      <textarea
        name="from_message"
        value={formData.from_message}
        onChange={(e) => onChange('from_message', e.target.value)}
        placeholder="Enter Your Message"
        required
      />
      <button type="submit" disabled={isSending}>
        {isSending ? 'Sending...' : 'Send Message'}
      </button>
    </div>
  </form>
);

export function ChatWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [formData, setFormData] = useState({
    from_name: '',
    from_email: '',
    from_phone: '',
    from_subject: '',
    from_message: ''
  });
  const [isSending, setIsSending] = useState(false);

  const handleFormChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();
    setIsSending(true);

    try {
      const userMessage = { 
        content: `Name: ${formData.from_name}\nEmail: ${formData.from_email}\nMessage: ${formData.from_message}`,
        isUser: true 
      };
      setMessages(prev => [...prev, userMessage]);

      await emailjs.send(
        'default_service',
        'template_x584ifd',
        { ...formData, title: 'New Support Request' }
      );

      const botMessage = { 
        content: 'Thank you for your message! We will respond to your inquiry shortly.',
        isUser: false 
      };
      setMessages(prev => [...prev, botMessage]);

      Swal.fire({
        icon: 'success',
        title: 'Message Sent!',
        text: 'We have received your inquiry and will respond shortly.',
        confirmButtonColor: '#FFA916',
      });

      setFormData({
        from_name: '',
        from_email: '',
        from_phone: '',
        from_subject: '',
        from_message: ''
      });

    } catch (error) {
      console.error('Email sending failed:', error);
      Swal.fire({
        icon: 'error',
        title: 'Sending Failed',
        text: 'There was a problem sending your message. Please try again later.',
        confirmButtonColor: '#FFA916',
      });
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className={`chat-widget ${isOpen ? 'open' : ''}`}>
      <style jsx global>{`
        .chat-widget {
          position: fixed;
          bottom: 1rem;
          right: 1rem;
          z-index: 1000;
          transition: all 0.3s ease;
        }

        .chat-widget.open {
          bottom: 0;
          right: 0;
          width: 100%;
          max-width: 24rem;
          height: 100%;
          max-height: 40rem;
        }

        @media (max-width: 640px) {
          .chat-widget.open {
            max-width: 100%;
            max-height: 100%;
            border-radius: 0;
          }
        }

        .chat-header {
          padding: 1rem;
          background: linear-gradient(to right, #024A59, #0A6B7D);
          color: white;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top-left-radius: 1rem;
          border-top-right-radius: 1rem;
        }

        .header-content {
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .bot-icon {
          height: 1.5rem;
          width: 1.5rem;
          color: #FFA916;
        }

        .close-button {
          background: transparent;
          border: none;
          cursor: pointer;
          padding: 0.25rem;
          border-radius: 50%;
          transition: all 0.2s;
          color: white;
        }

        .close-button:hover {
          color: #FFA916;
        }

        .chat-messages {
          height: calc(100% - 12rem);
          padding: 1rem;
          background: linear-gradient(to bottom, #F5F5F5 0%, #EAEAEA 100%);
          overflow-y: auto;
        }

        .messages-container {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
        }

        .message {
          display: flex;
          animation: messageEnter 0.3s ease-out;
        }

        .message.user {
          justify-content: flex-end;
        }

        .message-content {
          max-width: 85%;
          padding: 0.75rem;
          border-radius: 1rem;
          font-size: 0.875rem;
          line-height: 1.4;
          white-space: pre-line;
        }

        .message.user .message-content {
          background: #FFA916;
          color: #024A59;
          border-bottom-right-radius: 0.25rem;
        }

        .message.bot .message-content {
          background: white;
          color: #374151;
          border-bottom-left-radius: 0.25rem;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          border: 1px solid rgba(255,169,22,0.1);
        }

        .typing-indicator {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: #024A59;
          animation: typingIndicatorEnter 0.2s ease-out;
        }

        .dots {
          display: flex;
          gap: 0.375rem;
        }

        .dot {
          width: 0.625rem;
          height: 0.625rem;
          background: #FFA916;
          border-radius: 50%;
          animation: bounce 1s infinite;
        }

        .chat-input {
          padding: 1rem;
          background: white;
          border-top: 1px solid rgba(0,0,0,0.1);
          border-bottom-left-radius: 1rem;
          border-bottom-right-radius: 1rem;
        }

        .input-fields {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        input, textarea {
          width: 100%;
          padding: 0.625rem 1rem;
          border-radius: 0.75rem;
          border: 1px solid rgba(0,0,0,0.1);
          font-size: 0.875rem;
          color: #374151;
          transition: all 0.2s;
        }

        input:focus, textarea:focus {
          border-color: #FFA916;
          box-shadow: 0 0 0 2px rgba(255,169,22,0.2);
          outline: none;
        }

        textarea {
          min-height: 4rem;
          resize: vertical;
        }

        button[type="submit"] {
          padding: 0.625rem 1rem;
          border-radius: 0.75rem;
          background: #FFA916;
          border: none;
          cursor: pointer;
          transition: all 0.2s;
          color: white;
          font-size: 0.875rem;
          font-weight: 500;
          align-self: flex-end;
        }

        button[type="submit"]:disabled {
          background: rgba(0,0,0,0.1);
          cursor: not-allowed;
        }

        @keyframes messageEnter {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes typingIndicatorEnter {
          from { opacity: 0; transform: translateX(-10px); }
          to { opacity: 1; transform: translateX(0); }
        }

        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-5px); }
        }

        @media (max-width: 640px) {
          .chat-widget:not(.open) {
            bottom: 0.5rem;
            right: 0.5rem;
          }
          
          .message-content {
            max-width: 90%;
          }
        }
      `}</style>

      {!isOpen ? (
  <button
            onClick={() => setIsOpen(true)}
            style={{
              background: '#FFA916',
              color: '#024A59',
              borderRadius: '50%',
              padding: '16px',
              boxShadow: '0 4px 20px rgba(2,74,89,0.2)',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.3s',
              animation: 'widgetEntrance 0.3s ease-out',
              ':hover': { transform: 'scale(1.05)', background: '#E69500' }
            }}
          >
            <MessageCircle style={{ height: '28px', width: '28px' }} />
          </button>
      ) : (
        <div className="chat-container">
          <ChatHeader onClose={() => setIsOpen(false)} />
          <ChatMessages messages={messages} isTyping={isSending} />
          <ChatInput 
            formData={formData} 
            onChange={handleFormChange} 
            onSend={handleSendMessage}
            isSending={isSending}
          />
        </div>
      )}
    </div>
  );
}